import { defineModule } from '@/js/utils/helpers';

const getElements = () => ({
  lsbInputs: document.querySelectorAll<HTMLElement>('.lsb-form-input'),
});

const onLsbInputChange = (e: Event) => {
  const { target } = e;
  if (!(target instanceof HTMLInputElement)) return;

  target.classList.toggle('has-value', target.value.trim() !== '');
};

export default defineModule(
  () => {
    const { lsbInputs } = getElements();

    lsbInputs.forEach((input) => {
      input.addEventListener('input', onLsbInputChange, { passive: true });
      input.addEventListener('change', onLsbInputChange, { passive: true });
    });
  },
  () => {
    const { lsbInputs } = getElements();

    lsbInputs.forEach((input) => {
      input.removeEventListener('input', onLsbInputChange);
      input.removeEventListener('change', onLsbInputChange);
    });
  },
);
